// extracted by mini-css-extract-plugin
module.exports = {"resourcesBlock":"ResourcesBlock_resourcesBlock__21W94"};